import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';

// Proto: people.Caregiver.
export default class Caregiver extends Fragment {
  declare [Type]: 'people/caregiver';

  @attr('string', { defaultValue: '' })
  declare contactHash: string;

  @array('string')
  declare schools: StatefulArray<string>;

  @array('string')
  declare learnerIds: StatefulArray<string>;
}
